.listItem {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
}

.multipleSkuColumn {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: var(--accordion-transition);
  height: auto;
  overflow: hidden;
}
.multipleSkuColumn[data-collapsed=true] {
  height: 2.25rem;
}

.divider {
  height: 1px;
  width: 100%;
  margin: 0 10px;
  background-color: var(--static-divider-standard);
}

.listItem:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
}

.listItem:hover {
  outline: 1px solid var(--static-divider-standard);
}

.listItemMultipleSkuContainer {
  width: 100%;
  padding: 0.5rem;
  border-top: 1px dashed var(--static-divider-standard);
}

.listItemMultipleSkuTitle {
  margin-bottom: 10px;
}

.truncate {
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.labelNoTruncate {
  min-width: max-content;
}

.minWidth0 {
  min-width: 0;
}

.listItemContent {
  width: 100%;
  padding: 0.5rem;
  min-width: 0;
}
.listItemLeftColumn {
  width: 100%;
  min-width: 0;
  padding: 0 0.5rem;
}
.listItemRightColumn {
  min-width: 0;
  white-space: nowrap;
  min-width: max-content;
}

.listItemTitleContainer {
  width: 100%;
}
.listItemTitle {
  display: block;
  width: 100%;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.notSellingYet {
  white-space: nowrap;
  color: var(--static-text-weak);
  margin-right: 5px;
}

.listingBadgeContainer {
  margin-right: 10px;
}
